import React from 'react'

import {
    Checkbox,
    FormControl,
    InputLabel,
    ListItemText,
    Select,
    Input,
    MenuItem,
    Chip,
} from '@material-ui/core'
import { IdentifiableNamedObject } from '../../models'
import { useMultiSelectStyles } from './styles'

interface Props {
    label: string
    keyIdentifier: string
    options: IdentifiableNamedObject[]
    selectedOptions: number[]
    onChange: (newOptions: number[]) => void
    disabled?: boolean
    style?: {
        formControl: React.CSSProperties
    }
    variant?: 'chips' | 'compact'
}

export const MultiSelector = (props: Props) => {
    const { variant = 'compact' } = props

    const handleChange = (event: React.ChangeEvent<{ value: unknown }>) => {
        const selectedOptions = event.target.value as number[]
        props.onChange(selectedOptions)
    }

    const classes = useMultiSelectStyles()

    const renderCompactValue = (selected: unknown) => {
        const ids = selected as number[]
        if (ids.length === 0) return ''

        const names = ids
            .map((id) => props.options.find((opt) => opt.id === id)?.name)
            .filter(Boolean)

        if (names.length <= 2) {
            return names.join(', ')
        }
        return `${names[0]}, ${names[1]} +${names.length - 2}`
    }

    const renderChipsValue = (selected: unknown) => (
        <div className={classes.chips}>
            {(selected as number[]).map((value) => {
                const option = props.options.find((opt) => opt.id === value)
                return (
                    <Chip
                        key={`${props.keyIdentifier}_CHIP_${
                            option ? option.id : -1
                        }`}
                        label={option ? option.name : 'unknown'}
                        className={classes.chip}
                    />
                )
            })}
        </div>
    )

    return (
        <FormControl
            className={classes.formControl}
            style={props.style?.formControl}
        >
            <InputLabel>{props.label}</InputLabel>
            <Select
                multiple
                value={props.selectedOptions}
                onChange={handleChange}
                input={<Input />}
                disabled={props.disabled}
                renderValue={
                    variant === 'compact'
                        ? renderCompactValue
                        : renderChipsValue
                }
            >
                {props.options.map((opt) => {
                    const isSelected = props.selectedOptions.includes(opt.id)
                    return (
                        <MenuItem
                            key={`${props.keyIdentifier}_MENU_ITEM_${opt.id}`}
                            value={opt.id}
                        >
                            <Checkbox
                                checked={isSelected}
                                color="primary"
                                size="small"
                            />
                            <ListItemText primary={opt.name} />
                        </MenuItem>
                    )
                })}
            </Select>
        </FormControl>
    )
}
